module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"alt":{"logo":"Logo of %{user_en}"}}}')
  delete Component.options._Ctor
}
